import JTopo from '../../static/libs/jtopo-0.4.8.js'
import contextmenu from './contextmenu.js'
// import menuUtil from '../../static/js/menuUtil.js'

import { nodeParamTemplate, linkParamTemplate } from './paramTemplate.js'

const defaultOptions = {
  stageContextmenuRef: null, // 右键菜单节点
  disabled: true, // 是否只读
  vue: null,
  baseImageUrl: '',
  link: {
    lineWidth: 3,
    strokeColor: '0,200,255',
  },
  scene: {
    backgroundColor: '0,200,255',
    background: '153,153,153',
  },
  defaultPathData: {
    from: {
      id: '',
      code: '',
      name: '',
    },
    to: {
      id: '',
      code: '',
      name: '',
    },
  },
}
class WorkflowUtil {
  constructor(divId, option = {}) {
    var canvas = divId
    if (typeof divId === 'string') {
      canvas = document.getElementById(divId)
    }

    this.canvas = canvas

    this.options = Object.assign({}, defaultOptions, option)
    // console.log("this.options", this.options);
    var stage = new JTopo.Stage(canvas)
    var scene = new JTopo.Scene(stage)
    stage.wheelZoom = 1.2 // 设置鼠标缩放比例
    // scene.background = this.options.scene.background;
    this.stage = stage

    this.scene = scene

    this.scene.backgroundColor = this.options.scene.backgroundColor

    var that = this
  } // end constructor
  // 场景添加右键事件
  addContextmenuForScene(menuItems) {
    var that = this
    if (this.options.disabled) {
      return
    }

    contextmenu.addEventListener(this.scene, menuItems, (event, name) => {
      that.sceneContextmenuOnclick(event, name)
    })

    this.stage.addEventListener('mouseup', function (event) {
      if (that.scene.currentElement) {
        that.currentNode = that.scene.currentElement
        var elementType = that.scene.currentElement.elementType
        // console.log("this.x,this.y", that.currentNode.x, that.currentNode
        //   .y, that.currentNode);

        if (elementType == 'node') {
          that.currentNode._data.offsetX = parseInt(that.currentNode.x)
          that.currentNode._data.offsetY = parseInt(that.currentNode.y)
        } else if (elementType == 'link') {
        }
      }
    })

    this.stage.addEventListener('dbclick', function (event) {
      if (!that.scene.currentElement || !that.scene.currentElement.elementType) {
        return
      }
      var elementType = that.scene.currentElement.elementType

      // console.log("  elementType", elementType, that.scene.currentElement);
      if (elementType == 'node') {
        that.options.vue.handleDbClickNodeMenu(event, that.scene.currentElement._data)
      } else if (elementType == 'link') {
        that.options.vue.handleDbClickLinkMenu(event, that.scene.currentElement._data)
      }
    })
  }

  // 画布点击菜单回掉方法
  sceneContextmenuOnclick(event, name) {
    var mousecoord = this.scene.mousecoord
    var data = null
    if (this.currentNode) data = this.currentNode._data

    if (name == '连接起始点') {
      // 生成连线
      this.startMoveLink(event, mousecoord)
    }
    //       console.log("  this.scene.mousecoord",  this.scene.mousecoord);
    // //  var mousecoord=this.scene.mousecoord;
    //     this.addWNodeEntity();
    //   //  this.addNode(name,mousecoord.x,mousecoord.y);
    // }

    this.options.vue.handleClickMenu(event, name, mousecoord, data)

    // return;
    //
    // var that=this;
    // if(name=="添加节点"){
    //       console.log("  this.scene.mousecoord",  this.scene.mousecoord);
    // //  var mousecoord=this.scene.mousecoord;
    //     this.addWNodeEntity();
    //   //  this.addNode(name,mousecoord.x,mousecoord.y);
    // }else if(name=="连接"){
    //   if(that.currentNode&& that.pathFromNode){//2个连接点，建立链接
    //       if(that.currentNode== that.pathFromNode){
    //         that.currentNode.alpha=1;
    //         that.pathFromNode.alpha=1;
    //         that.currentNode=null;
    //         that.pathFromNode=null;
    //         return;
    //       }
    //
    //       that.currentNode.alpha=1;
    //       that.addLink(that.pathFromNode,that.currentNode,"连接");
    //
    //       that.currentNode.alpha=1;
    //       that.pathFromNode.alpha=1;
    //       that.currentNode=null;
    //       that.pathFromNode=null;
    //   }else if(that.currentNode && that.pathFromNode==null){//设置连接开始节点
    //     that.currentNode.alpha=0.5;
    //     that.pathFromNode=that.currentNode;
    //   }else{
    //     alert("请选择节点右键");
    //   }
    // }
    // that.currentNode=null;
  }

  // 根据code获取节点
  getNodeByCode(code) {
    var scene = this.stage.childs[0]
    var that = this

    var nodes = scene.childs.filter(function (e) {
      // console.log("getNodeByCode.e",e,code);
      return e instanceof JTopo.Node && e._data.code == code
    })

    if (nodes && nodes.length > 0) return nodes[0]

    return null
  }

  addLinkByPathEntity(pathEntity) {
    var fromNode = this.getNodeByCode(pathEntity.from.code)
    var toNode = this.getNodeByCode(pathEntity.to.code)
    this.scene.add(this.addLink(fromNode, toNode, pathEntity))
  }

  // 简单连线
  addLink(fromNode, toNode, pathEntity) {
    if (!pathEntity.condition) pathEntity.condition = ''
    // var link = new JTopo.FlexionalLink(fromNode, toNode, pathEntity.condition);
    var link = new JTopo.CurveLink(fromNode, toNode, pathEntity.condition)
    link._data = pathEntity
    link.lineWidth = 1 // 线宽
    link.arrowsRadius = 10 // 箭头大小
    //  link.dashedPattern = dashedPattern; // 虚线
    link.bundleOffset = 0 // 折线拐角处的长度
    link.bundleGap = 20 // 线条之间的间隔
    link.textOffsetY = 3 // 文本偏移量（向下3个像素）
    // link.strokeColor = JTopo.util.randomColor(); // 线条颜色随机
    link.strokeColor = this.options.link.strokeColor

    var linkParm = Object.assign({}, linkParamTemplate.default)

    for (var parm in linkParm) {
      link[parm] = linkParm[parm]
    }

    return link
  }
  //  添加节点到画布
  addNodeByWNodeEntity(wNodeEntity) {
    var node = null

    var width = 120
    var height = 120
    var shape = null
    if (wNodeEntity.node) {
      if (wNodeEntity.node.width) {
        width = wNodeEntity.node.width
      }
      if (wNodeEntity.node.height) {
        height = wNodeEntity.node.height
      }
      shape = wNodeEntity.node.code
    }

    var nodeParm = Object.assign({}, nodeParamTemplate.default, nodeParamTemplate[shape])

    // console.log("nodeParm", nodeParm, shape, nodeParamTemplate[shape],
    //   nodeParamTemplate.default);

    node = new JTopo[nodeParm.nodeType](wNodeEntity.name)

    //  node.setSize(width, height);  // 尺寸

    for (var parm in nodeParm) {
      if (parm == 'image') {
        if (nodeParm[parm]) {
          var url = nodeParm[parm] + '?v=' + nodeParamTemplate.version
          node.setImage(url, true)
        }
      } else {
        node[parm] = nodeParm[parm]
      }
    }

    node._data = wNodeEntity

    this.offsetX = 0
    this.offsetY = 0
    if (!wNodeEntity.offsetX) {
      this.offsetX = this.offsetX + 60
      wNodeEntity.offsetX = this.offsetX
    }

    if (!wNodeEntity.offsetY) {
      this.offsetY = this.offsetY + 60
      wNodeEntity.offsetY = this.offsetY
    }
    // console.log("wNodeEntity.offsetX", wNodeEntity.offsetX, wNodeEntity.offsetY);
    node.setLocation(wNodeEntity.offsetX, wNodeEntity.offsetY)

    this.scene.add(node)
    this.nodeAddEventListener(node)
  }

  // addNode(name,pageX,pageY,data){
  //   var  node = new JTopo.Node(name);
  //   node.setLocation(pageX,pageY);
  //   node.setSize(120, 44);  // 尺寸
  //   node.borderRadius = 4; // 圆角
  //   node._data=data;//原始数据
  //   // node.borderWidth = 2; // 边框的宽度
  //   // node.borderColor = '255,255,255'; //边框颜色
  //   node.fillColor = '110, 110, 255'; // 填充颜色
  //   //   node.radius = 24; // 半径
  //   //   node.fillColor = '0,0, 255'; // 填充颜色
  //   node.textPosition = 'Bottom_Center'; // 文本位置
  //   node.text=name;
  //   node.font='12px PingFangSC-Medium 12px';
  //   this.scene.add(node);
  //   var that=this;
  // }
  // node 节点添加事件
  // linkEventListener(link){
  //       var that=this;
  //
  //       if(this.options.disabled){
  //             return;
  //       }
  //
  //
  //     // link.dbclick( function(event){
  //     //           console.log(this._data);
  //     //               that.options.vue.handleDbClickNodeMenu(event,this._data);
  //     //              that.currentNode = this;
  //     //              return false;
  //     //          });
  //     // link.addEventListener('mouseup', function(event){
  //     //              that.currentNode = this;
  //     //              console.log("this.x,this.y",this.x,this.y)
  //     //              this._data.offsetX=parseInt(this.x);
  //     //              this._data.offsetY=parseInt(this.y);
  //     //
  //     //              return false;
  //     //          });
  //
  // }
  // node 节点添加事件
  nodeAddEventListener(node) {
    var that = this
    if (this.options.disabled) {
    }

    // node.dbclick( function(event){
    //
    //               that.options.vue.handleDbClickNodeMenu(event,this._data);
    //              that.currentNode = this;
    //              return false;
    //          });
    // node.addEventListener('mouseup', function(event){
    //              that.currentNode = this;
    //              console.log("this.x,this.y",this.x,this.y)
    //              this._data.offsetX=this.x;
    //              this._data.offsetY=this.y;
    //              return false;
    //          });
  }
  // 加载数据
  /**
  data  {
       //  "business":null,
       //  "nodes":[],//List<WBusinessNodeEntity>
       //  "paths":[]//List<WBusinessPathEntity>
    }
    */
  loadData(data) {
    // console.log("loadData,data", data);
    this.scene.clear()
    // 添加节点
    if (data.nodes) this._loadDataOfNodes(data.nodes)
    // 添加连线
    if (data.paths) this._loadDataOfPaths(data.paths)
    // this.addSceneEvent();
    this.initMoveLink()
    // console.log("loadData,data.nodes,data.paths end");
  }
  // 添加节点
  _loadDataOfNodes(nodes) {
    if (!nodes || nodes.length <= 0) return
    for (var i = 0; i < nodes.length; i++) {
      this.addNodeByWNodeEntity(nodes[i])
    }
  }

  _loadDataOfPaths(paths) {
    if (!paths || paths.length <= 0) return
    for (var i = 0; i < paths.length; i++) {
      this.addLinkByPathEntity(paths[i])
    }
  }

  addWNodeEntity() {
    this.options.vue.handleShowEditNodeModal({})
  }

  // 初始化动态连线数据
  initMoveLink() {
    var tempNodeA = new JTopo.Node()
    tempNodeA.setSize(1, 1)

    var tempNodeZ = new JTopo.Node()
    tempNodeZ.setSize(1, 1)
    let that = this

    var link = this.addLink(tempNodeA, tempNodeZ, [])

    this.moveLinkData = {
      nodeA: tempNodeA,
      nodeZ: tempNodeZ,
      link: link,
      beginNode: null,
    }
    this.moveOfLink = link
    this.moveOfBeginNode = null

    // 生成线跟着鼠标移动
    this.scene.mousemove(function (e) {
      tempNodeZ.setLocation(e.x, e.y)
    })

    // 释放当前移动线
    that.scene.mousedown(function (e) {
      if (
        e.target == null ||
        e.target === that.moveLinkData.beginNode ||
        e.target === that.moveLinkData.link
      ) {
        that.scene.remove(that.moveLinkData.link)
      }
    })

    // 是否添加连线判断
    that.scene.mouseup(function (e) {
      // 没有起始节点
      if (!that.moveLinkData.beginNode) return

      var beginNode = that.moveLinkData.beginNode
      var link = that.moveLinkData.link
      var tempNodeA = that.moveLinkData.nodeA
      var tempNodeZ = that.moveLinkData.nodeZ

      if (e.target && e.target.elementType == 'node') {
        // if(e.button == 2){
        //     that.scene.remove(link);
        //     return;
        // }
        if (e.target != null && e.target instanceof JTopo.Node) {
          if (beginNode == null) {
            // 又 startMoveLink 方法启动连线
          } else if (beginNode !== e.target) {
            var endNode = e.target
            that.options.vue.handleClickMenu(e, '连接结束点', null, endNode._data)
            that.moveLinkData.beginNode = null
            that.scene.remove(link)
          } else {
            that.moveLinkData.beginNode = null
            that.scene.remove(link)
          }
        } else {
          that.moveLinkData.beginNode = null
          that.scene.remove(link)
        }
      }
    })
  }

  // 启动连线
  startMoveLink(e, mousecoord) {
    var that = this
    var beginNode = this.moveLinkData.beginNode
    var link = this.moveLinkData.link
    var tempNodeA = this.moveLinkData.nodeA
    var tempNodeZ = this.moveLinkData.nodeZ

    var selectedNode = this.currentNode

    if (selectedNode.elementType == 'node') {
      if (e.button == 2) {
        that.scene.remove(link)
        return
      }
      if (selectedNode instanceof JTopo.Node) {
        beginNode = selectedNode
        that.scene.add(link)
        tempNodeA.setLocation(mousecoord.x, mousecoord.y)
        tempNodeZ.setLocation(mousecoord.x, mousecoord.y)
      } else {
        that.scene.remove(link)
      }
    }

    this.moveLinkData.beginNode = beginNode
  }

  addSceneEvent() {
    var beginNode = null
    var tempNodeA = new JTopo.Node()
    tempNodeA.setSize(1, 1)

    var tempNodeZ = new JTopo.Node()
    tempNodeZ.setSize(1, 1)
    let that = this
    var link = this.addLink(tempNodeA, tempNodeZ, [])
    that.scene.mouseup(function (e) {
      if (e.target && e.target.elementType == 'node') {
        if (e.button == 2) {
          that.scene.remove(link)
          return
        }
        if (e.target != null && e.target instanceof JTopo.Node) {
          if (beginNode == null) {
            beginNode = e.target
            that.scene.add(link)
            tempNodeA.setLocation(e.x, e.y)
            tempNodeZ.setLocation(e.x, e.y)
          } else if (beginNode !== e.target) {
            var endNode = e.target
            var l = that.addLink(beginNode, endNode, [])
            // that.vueEvent(beginNode,endNode);

            var pathData = {
              from: this.fromNode,
              to: this.toNode,
            }
            this.options.vue.handleLinkNodes(pathData)
            that.scene.add(l)
            beginNode = null
            that.scene.remove(link)
          } else {
            beginNode = null
          }
        } else {
          that.scene.remove(link)
        }
      }
    })

    that.scene.mousedown(function (e) {
      if (e.target == null || e.target === beginNode || e.target === link) {
        that.scene.remove(link)
      }
    })
    that.scene.mousemove(function (e) {
      tempNodeZ.setLocation(e.x, e.y)
    })
  }

  vueEvent(beginNode, endNode) {
    this.options.defaultPathData.from.id = beginNode.id
    this.options.defaultPathData.from.code = beginNode.code
    this.options.defaultPathData.from.name = beginNode.name
    this.options.defaultPathData.from['offsetX'] = beginNode.offsetX
    this.options.defaultPathData.from['offsetY'] = beginNode.offsetY
    this.options.defaultPathData.to.id = endNode.id
    this.options.defaultPathData.to.code = endNode.code
    this.options.defaultPathData.to.name = endNode.name
    this.options.defaultPathData.to['offsetX'] = endNode.offsetX
    this.options.defaultPathData.to['offsetY'] = endNode.offsetY
    this.options.vue.dataCopy.paths.push(this.options.defaultPathData)
  }
}

export default WorkflowUtil
